export const config = {
  apiUrl: 'api/v2',
  // apiUrl: 'http://easycontrolstg.eastus.cloudapp.azure.com:5000/api/v1',
};
